import { Link } from "@tanstack/react-router";

import { Button } from "../ui/primitives";

export function NotFoundPage() {
  return (
    <main id="main" className="mx-auto max-w-lg px-6 py-24 text-center">
      <h1 className="text-lg font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-muted">
        The link may be out of date, or the site it pointed at may have been removed.
      </p>
      <Link to="/sites" className="mt-6 inline-block">
        <Button variant="primary">Back to your sites</Button>
      </Link>
    </main>
  );
}
